export function validateAction(state, event) {
    const { phase } = state
    const { action } = state
    const { turn } = state
    switch (event.type) {

        case "PLAY_CARD":
            if (!action.canPlayCard) return false
            if (event.seat !== turn.currentSeat) return false
            return true

        case "PLAY_CARD_MESSAGE":
            if (!action.canPlayCard) return false
            if (event.seat === turn.currentSeat) return false
            return true

        case "TRUCO":
            if (action.phase !== "CARD_PLAY") return false
            if (state.bet.trucoLevel >= 3) return false
            return true

        case "RE_TRUCO":
            if (state.bet.trucoLevel < 1) return false
            if (state.bet.trucoLevel >= 3) return false
            return true

        case "FOUR":
            if (state.bet.trucoLevel < 2) return false
            if (state.bet.trucoLevel > 3) return false
            return true

        case "ACCEPT":
        case "REJECT":
            if (action.phase !== "BETTING") return false
            return true

        case "ENVIDO":
            if (state.cardsPlayed > 0) return false
            return true

        default:
            return true
    }
}